import { FETCH_PUBLICATIONS_LIST, FETCH_PUBLICATIONS_SUGGESTIONS } from "../actions/publicationsActions";

import { isFulfilled, isPending, isRejected } from "./reducerUtils";

const publicationsReducer = (
    state = {
        publicationsList: null,
        publicationsListLoading: false,
        publicationsListError: null,
        publicationsSuggestions: [],
    },
    action,
) => {
    switch (action.type) {
        case isFulfilled(FETCH_PUBLICATIONS_SUGGESTIONS):
            return { ...state, publicationsSuggestions: action.payload };
        case isFulfilled(FETCH_PUBLICATIONS_LIST):
            return {
                ...state,
                publicationsList: action.payload.publications.sort((a, b) => {
                    if (a.entity_name < b.entity_name) {
                        return -1;
                    }
                    if (a.entity_name > b.entity_name) {
                        return 1;
                    }
                    return 0;
                }),
                publicationsListLoading: false,
                publicationsListError: null,
            };
        case isPending(FETCH_PUBLICATIONS_LIST):
            return { ...state, publicationsListLoading: true, publicationsListError: null };
        case isRejected(FETCH_PUBLICATIONS_LIST):
            return { ...state, publicationsList: null, publicationsListLoading: false, publicationsListError: action.payload };
        default:
            return state;
    }
};

export default publicationsReducer;
